<script setup lang="ts">
  import { useBreakpointsStore } from '@/store'
  import { storeToRefs } from 'pinia'
  import { toRefs } from 'vue'

  const breakpointStore = useBreakpointsStore()
  const { md } = storeToRefs(breakpointStore)

  type Iprops = {
    title: string
    description: string
    textButton: string
    success: boolean
    icon?: string
  }

  const props = defineProps<Iprops>()
  const { title, description, success, textButton } = toRefs(props)

  const emit = defineEmits(['connect'])
</script>

<template>
  <card>
    <template #content>
      <div class="flex justify-content-between px-2 py-4 align-items-center">
        <!-- <div class="flex w-5rem">
          <svg
            class="w-3rem"
            data-name="zoho crm"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 348.53 347.38"
          >
            <path
              d="m167.91.1c48.56,0,97.13-.03,145.69-.1,7.07-.01,13.55,1.73,19.29,5.86,6.83,4.91,12.35,10.98,14.59,19.26,1.41,5.25.99,10.78.99,16.18.04,71.43.03,142.86.04,214.29,0,14.67.04,29.34-.02,44-.03,6.21.09,12.46-.49,18.63-1.02,10.78-6.6,18.89-15.74,24.68-4.64,2.94-9.58,4.42-15.1,4.41-47.74-.04-95.49-.02-143.23-.02h0c-46.94,0-93.88-.1-140.82.1-10.1.04-17.86-4.04-24.35-11.17-5.44-5.98-8.43-12.92-8.53-21.24-.45-37.83-.11-75.66-.15-113.49-.06-55.66,0-111.31-.07-166.97,0-6.15,1.41-11.57,4.46-17.08C9.83,7.74,18.01,2.74,28.34.41c1.45-.33,3-.34,4.5-.34m12.45,171.81c0,3.7.07,6.31-.01,8.92-.23,7.48,1.68,14.73,4.52,21.32,3.07,7.15,7.3,13.9,11.77,20.46,9.04,13.26,21.79,21.71,36.05,27.59,16.89,6.97,34.53,7.38,52.18,1.84,2.84-.89,4.2-2.29,4.65-5.05.49-3.01.53-5.86-2.17-7.95-2.35-1.81-4.77-2.26-7.87-1.52-22.08,5.32-42.51,2.2-60.26-12.78-14.35-12.11-22.18-27.67-23.75-46.34-.81-9.68.37-19.16,3.84-28.19,3.43-8.93,8.74-16.7,15.72-23.4,16.95-16.27,37.4-21.13,59.89-17.44,10.59,1.74,20.36,6.68,28.93,13.52,2.27,1.81,4.1,4,6.23,5.91,10.99,9.84,20.32,21.35,31.35,31.17,4.24,3.77,7.88,8.21,11.91,12.22,3.69,3.68,4.41,11.25.97,15.15-4.92,5.58-11.43,8.12-18.31,1.99-.82-.74-1.67-1.45-2.49-2.19-9.24-8.31-17.16-17.94-26.39-26.28-4.97-4.49-9.51-9.44-14.38-14.05-10.03-9.48-28.32-8.55-37.92,1.86-9.17,9.94-10.42,27.69,1.61,39.41,14.45,14.06,28.73,28.3,42.98,42.57,11.41,11.43,24.96,19.55,41.27,23.03,17.24,3.68,33.67,1.85,49.47-5.19,14.26-6.36,25.84-16.02,34.9-29.07,8.9-12.8,13.02-26.86,14.52-41.99.55-5.53-.67-10.93-1.54-16.38-1.13-7.03-2.86-13.85-5.91-20.22-6.85-14.32-16.67-26.03-30.25-34.71-17.06-10.9-35.32-15.58-55.42-12.58-4.46.67-9.02,1.04-13.15,3.11-2.47,1.23-4.11,2.97-4.43,5.96-.53,5.05,5.1,9.91,10.56,7.98,10-3.54,20.66-3.54,30.45-1.48,31.57,6.64,46.93,27.19,52.81,52.6,1.68,7.25,1.47,14.92.3,22.21-3.05,19.09-12.5,34.59-28.79,45.33-11.28,7.43-23.86,10.97-37.54,10.63-17.83-.44-33.18-6.4-45.73-19.23-7.79-7.96-15.56-15.95-23.62-23.63-7.84-7.49-15.55-15.09-22.72-23.21-3.17-3.59-2.48-7.6-.55-11.41,1.8-3.55,4.54-5.84,8.87-6.29,6.33-.67,10.94,2.25,14.86,6.5,11.93,12.94,25.04,24.7,37.33,37.28,7.97,8.15,17.96,9.4,28.7,6,10.11-3.2,15.14-10.92,17.38-20.43,2.14-9.09-1.02-17.46-7.12-24.14-10.67-11.69-21.94-22.84-33.52-33.64-6.37-5.94-11.92-12.66-19.23-17.72-10.44-7.21-21.05-13.55-33.81-15.68-8.87-1.48-17.64-2.3-26.68-.89-23.63,3.68-42.44,15.13-56.16,34.48-9.49,13.39-15.54,28.17-14.3,44Z"
              style="fill: #4084be"
            />
            <path
              d="m44.67,171.33c-1.24-15.84,4.81-30.61,14.3-44,13.71-19.35,32.52-30.8,56.16-34.48,9.04-1.41,17.81-.59,26.68.89,12.75,2.13,23.37,8.46,33.81,15.68,7.32,5.06,12.87,11.78,19.23,17.72,11.58,10.8,22.85,21.95,33.52,33.64,6.1,6.68,9.26,15.05,7.12,24.14-2.24,9.5-7.28,17.23-17.38,20.43-10.74,3.4-20.74,2.15-28.7-6-12.29-12.58-25.4-24.34-37.33-37.28-3.92-4.25-8.54-7.17-14.86-6.5-4.33.46-7.07,2.74-8.87,6.29-1.93,3.81-2.62,7.82.55,11.41,7.17,8.12,14.88,15.73,22.72,23.21,8.05,7.69,15.83,15.67,23.62,23.63,12.56,12.83,27.9,18.79,45.73,19.23,13.68.34,26.26-3.2,37.54-10.63,16.29-10.74,25.74-26.24,28.79-45.33,1.17-7.29,1.38-14.95-.3-22.21-5.88-25.41-21.24-45.96-52.81-52.6-9.79-2.06-20.46-2.06-30.45,1.48-5.46,1.93-11.09-2.93-10.56-7.98.32-2.99,1.96-4.73,4.43-5.96,4.13-2.07,8.69-2.44,13.15-3.11,20.1-3,38.37,1.67,55.42,12.58,13.58,8.68,23.4,20.39,30.25,34.71,3.05,6.37,4.78,13.19,5.91,20.22.87,5.46,2.09,10.85,1.54,16.38-1.5,15.13-5.62,29.19-14.52,41.99-9.06,13.04-20.64,22.71-34.9,29.07-15.8,7.04-32.23,8.86-49.47,5.19-16.31-3.48-29.86-11.6-41.27-23.03-14.25-14.27-28.53-28.51-42.98-42.57-12.04-11.72-10.79-29.47-1.61-39.41,9.6-10.4,27.9-11.34,37.92-1.86,4.87,4.6,9.41,9.56,14.38,14.05,9.23,8.34,17.15,17.96,26.39,26.28.82.74,1.67,1.45,2.49,2.19,6.88,6.14,13.38,3.6,18.31-1.99,3.44-3.9,2.72-11.47-.97-15.15-4.03-4.02-7.67-8.45-11.91-12.22-11.03-9.82-20.36-21.32-31.35-31.17-2.13-1.91-3.96-4.1-6.23-5.91-8.58-6.84-18.34-11.78-28.93-13.52-22.48-3.7-42.94,1.17-59.89,17.44-6.98,6.7-12.29,14.46-15.72,23.4-3.47,9.04-4.65,18.52-3.84,28.19,1.57,18.68,9.4,34.23,23.75,46.34,17.75,14.98,38.18,18.09,60.26,12.78,3.1-.75,5.52-.3,7.87,1.52,2.7,2.09,2.66,4.94,2.17,7.95-.45,2.76-1.81,4.16-4.65,5.05-17.65,5.54-35.28,5.13-52.18-1.84-14.26-5.88-27.01-14.34-36.05-27.59-4.47-6.56-8.7-13.31-11.77-20.46-2.83-6.59-4.75-13.84-4.52-21.32.08-2.61.01-5.22.01-8.92Z"
              style="fill: #fff"
            />
          </svg>
        </div> -->
        <div class="pr-4">
          <i class="pi" :class="icon" style="font-size: 2.5rem" />
        </div>
        <div class="flex flex-grow-1">
          <div>
            <div class="font-semibold text-xl mb-2">{{ title }}</div>
            <div>
              {{ description }}
            </div>
          </div>
        </div>
        <div class="flex pl-1">
          <Button v-if="!success" :label="textButton" small class="mb2" @click="emit('connect')">
            <!-- <span v-else>{{ t('settingsIndex.connect') }}</span> -->
          </Button>
          <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="currentColor" class="text-green-600 opacity-30" height="50px" width="50px">
            <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" />
          </svg>
        </div>
      </div>
    </template>
  </card>
</template>

<!-- <style scoped lang="scss">
  #integration-card {
    max-width: 100%;

    .p-card-title {
      text-align: center;
    }

    .p-card-content {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 64px !important;
      padding-right: 64px !important;
      padding-top: 48px !important;
      padding-bottom: 48px !important;
    }

    &.failed {
      .p-card-content {
        padding-bottom: 24px !important;
      }
    }
  }
</style> -->
